import React, { SyntheticEvent, useEffect } from "react";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Certificate } from "../../Certificate";
import ButtonPrimary from "../../layout/ButtonPrimary";
import FormSkeleton from "../../layout/FormSkeleton";
import CompanyForm from "./CompanyForm";
import PublicForm from "./PublicForm";

interface MainFormProps {
  loading: boolean;
  onSubmit: (
    event: SyntheticEvent,
    data: Certificate,
    ref: React.RefObject<ReCAPTCHA>,
    isInternal: boolean
  ) => void;
  validate: (certificate: Certificate, isInternal: boolean) => void;
}

export default function MainForm({
  onSubmit,
  validate,
  loading,
}: MainFormProps) {
  const [data, setData] = useState<Certificate>(new Certificate({}));
  const [loadingIP, setLoadingIP] = useState<boolean>(true);
  const [isInternal, setIsInternal] = useState<boolean>(false);
  const [isDateInvoiceActive, setisDateInvoiceActive] = useState("");
  const recaptchaRef = React.createRef<ReCAPTCHA>();

  const inputFields = [
    {
      name: "date",
      text: `дата выпуска сертификата`,
      type: "date",
      public: true,
    },
    { name: "certification_number", text: "номер сертификата", public: true },
    {
      name: "date_invoice",
      text: "дата выпуска накладной",
      type: "date",
      public: true,
    },
    { name: "gov_number", text: "номер вагона (гос. номер)", public: true },
    { name: "delivery_number", text: "номер поставки", public: false },
    { name: "invoice_number", text: "номер накладной", public: false },
    { name: "contractor", text: "контрагент (ИНН)", public: false },
  ];

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    const trimmed = typeof value === "string" ? value.trim() : value;

    setData((prev) => {
      const next: Record<string, unknown> = { ...prev, [name]: trimmed };

      if (name === "date") {
        if (trimmed) {
          setisDateInvoiceActive("date");
          next.date_invoice = "";
          next.gov_number = "";
        } else {
          setisDateInvoiceActive(prev.date_invoice ? "date_invoice" : "");
          next.certification_number = "";
        }
      }

      if (name === "date_invoice") {
        if (trimmed) {
          setisDateInvoiceActive("date_invoice");
          next.date = "";
          next.certification_number = "";
        } else {
          setisDateInvoiceActive(prev.date ? "date" : "");
          next.gov_number = "";
        }
      }

      return new Certificate(next);
    });
  };

  const getClientIP = () => {
    fetch("/api/ip")
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        setIsInternal(response.isInternal);
        setLoadingIP(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingIP(false);
      });
  };

  useEffect(() => {
    getClientIP();
  }, []);

  if (!loadingIP) {
    return (
      <form
        className="py-4 flex flex-col w-full lg:w-[63%]"
        onSubmit={(event) => onSubmit(event, data, recaptchaRef, isInternal)}
        id="myhtmlForm"
      >
        <div
          className={`flex flex-wrap ${
            !isInternal ? "justify-center" : "justify-between"
          } items-end  gap-4 w-full mb-6`}
        >
          {!isInternal && (
            <PublicForm
              isDateInvoiceActive={isDateInvoiceActive}
              handleChange={handleChange}
              data={data}
            />
          )}
          {isInternal && (
            <CompanyForm
              isDateInvoiceActive={isDateInvoiceActive}
              handleChange={handleChange}
              data={data}
            />
          )}
        </div>
        <div className="m-auto mb-8">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LdGoQohAAAAAEF-V_QJK7OJjabOmwDrEXRPNdGP"
            onChange={() => {}}
          />
        </div>
        {!loading && (
          <ButtonPrimary
            w="w-full sm:w-fit m-auto px-20 lg:px-32 pb-1 pt-1"
            text="найти"
            p="pb-1"
            size="xl"
            onClick={() => validate(data, isInternal)}
          />
        )}
      </form>
    );
  } else {
    return <FormSkeleton inputFields={inputFields} />;
  }
}
